'use strict'
import $ from 'jquery';
import ColorCode from '../util/color_code.js';
import BarChart from './BarChart.js';


class ExpandIcon {
    constructor(id) {
        this.id = id;
        this.getExpandIcon = this.getExpandIcon.bind(this);
    }

    toggleDetails(event) {
        const PREV_ID = window.global.state.id;
        const tabHeight = window.global.constants.tabHeight;

        // The number of the search result id that was clicked
        let id = $(event.target.parentNode).attr('id');
        id = id.substring(id.lastIndexOf('-') + 1);

        let rotation = document.getElementById(`expand-icon-${id}`).style.transform;
        rotation = Number(rotation.match(/\d/g).join(''));
        rotation = `rotate(${rotation+45}deg)`;
        document.getElementById(`expand-icon-${id}`).style.transform = rotation;

        // Close the previously opened result
        if(PREV_ID) {
            var prevOpened = document.getElementById(`result-${PREV_ID}`);
        }

        // Rotate the expand icon for the previously opened result back to close
        if(PREV_ID && prevOpened.isOpen === true) {
            if(id !== PREV_ID) { 
                prevOpened.isOpen = false;
                let rotateBack = document.getElementById(`expand-icon-${PREV_ID}`).style.transform;
                rotateBack = Number(rotateBack.match(/\d/g).join(""));
                rotateBack = `rotate(${rotateBack+45}deg)`;
                document.getElementById(`expand-icon-${PREV_ID}`).style.transform = rotateBack;
            }
            document.getElementById(`result-${PREV_ID}`).style.height = `${tabHeight}px`;
            document.getElementById(`result-details-${PREV_ID}`).style.opacity = 0;
        }
        
        // Expand or collapse the flight details of the result tab that was clicked
        let clicked = document.getElementById(`result-${id}`);

        // Do an action depending on whether the clicked tab is open or closed
        if(clicked.isOpen) { // Default value of isOpen is set to false
            // Since the tab is open, close the result tab
            document.getElementById(`result-${id}`).style.height = `${tabHeight}px`;
            document.getElementById(`result-details-${id}`).style.opacity = 0;
            clicked.isOpen = false;
            let carbonChart = window.global.carbonChart;
            carbonChart.onCollapse();
        } else { 
            // The tab is closed, so open 

            //first give gradient color to the right edges of tickets
            console.log("opening tab");
            //change the position of dot
            let carbonChart = window.global.carbonChart;
            let currentCarbon = document.getElementById(`carbon-container-${id}`).innerText;
            currentCarbon = +currentCarbon.substring(0, currentCarbon.indexOf('k')).replace(' ', '');
            carbonChart.onExpand(currentCarbon);

            //get the legs for departure
            let outFlights = document.getElementById(`result-details-out-${id}`).getElementsByClassName('oneway-flight-details'); 
            const outFlightsLength = outFlights.length;
            //console.log(outFlightsLength);
            const outColorCodes = ColorCode[`length${outFlightsLength}`];
            //console.log(outColorCodes);
            for ( var i = 0; i < outFlightsLength; i++){
                outFlights[i].style.borderRightColor = outColorCodes[i];
            }

            //get the legs for return trip
            const inFlightsDiv = document.getElementById(`result-details-in-${id}`);
            //only do so when it's round trip
            if (inFlightsDiv !== null)  //round trip
            { 
                let inFlights = inFlightsDiv.getElementsByClassName('oneway-flight-details'); 
                const inFlightsLength = inFlights.length;
                //console.log(inFlightsLength);
                let inColorCodes = ColorCode[`length${inFlightsLength}`].slice();
                //console.log(ColorCode[`length${inFlightsLength}`]);
                const newInColorCodes = inColorCodes.reverse();
                //console.log(newInColorCodes);
                for ( var j = 0; j < inFlightsLength; j++){
                    inFlights[j].style.borderRightColor = newInColorCodes[j];
                }
            }
            //end changing ticket edge color


            let offset = document.getElementById(`result-details-${id}`).offsetHeight;
            offset += tabHeight + 32;
            document.getElementById(`result-${id}`).style.height = `${offset}px`;
            document.getElementById(`result-details-${id}`).style.opacity = 1;
            clicked.isOpen = true;
        }

        // Save the id for the next time another result is open
        window.global.state.id = id;
    }

    getExpandIcon() {
		let expandIcon = document.createElement('img');
		expandIcon.id = `expand-icon-${this.id}`;
		expandIcon.className = 'expand-icon';
		expandIcon.src = '../../assets/images/ecks.svg';
		expandIcon.onclick = this.toggleDetails;
        expandIcon.style.transform = 'rotate(45deg)';
        return expandIcon;
    }
}

export default ExpandIcon



// WEBPACK FOOTER //
// ./components/ExpandIcon.js